function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.586.02a6.567 6.567 0 015.278 10.489l3.55 3.003a1.357 1.357 0 11-1.913 1.913l-3.004-3.55A6.573 6.573 0 116.586.021zm0 11.77a5.192 5.192 0 10-5.192-5.193 5.192 5.192 0 005.192 5.192z",
  fill: "#596168",
  fillRule: "evenodd"
});

var SvgSearchIcon = function SvgSearchIcon(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgSearchIcon;